export default __webpack_public_path__ + "static/spotlight-search-fe755a52b3d3801ef9b301510125b965.png";